/**
 *
 * @param {Array} departments - The list of department IDs to filter by.
 * @param {Array} teams - The list of teams to filter. Each team should
 * have a `departmentsIds` array.
 * @returns {Array} A filtered array of teams that are associated
 * with any of the given department IDs.
 */
export const getFilteredTeams = (departments, teams) => {
  if (!Array.isArray(teams) || !Array.isArray(departments)) return []
  if (departments.length === 0) return []

  return teams.filter(({ departmentsIds }) =>
    Array.isArray(departmentsIds) &&
    departments.some((id) => departmentsIds.includes(id))
  )
}

/**
 * Returns a placeholder text for a team selection based on the presence of a
 * department ID and teams.
 *
 * @param {string} [departmentId=''] - The ID of the department.
 * @param {Array} [teams=[]] - The list of teams.
 * @param {string} [customPlaceholder=''] - A custom placeholder text.
 * @returns {string} The placeholder text for the team selection.
 */
export const getTeamPlaceholder = (departmentId = '', teams = [], customPlaceholder = '') => {
  const hasDepartment = !!departmentId
  const hasTeams = Array.isArray(teams) && teams.length

  let teamPlaceholder = customPlaceholder || 'Selecionar o time'

  if (hasDepartment && !hasTeams) {
    teamPlaceholder = 'Não existem times vinculados'
  }

  return teamPlaceholder
}
